import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { ProductVisual } from './components/ProductVisual';
import { HowItWorks } from './components/HowItWorks';
import { PlatformFeatures } from './components/PlatformFeatures';
import { WhyHubble } from './components/WhyHubble';
import { UseCases } from './components/UseCases';
import { ProofBand } from './components/ProofBand';
import { Founders } from './components/Founders';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { Partners } from './components/Partners';
function HomePage() {
  return <div className="min-h-screen bg-hubble-ink text-hubble-paper font-body selection:bg-hubble-signal selection:text-hubble-ink" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <ProductVisual data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <PlatformFeatures data-id="element-7" />
        <WhyHubble data-id="element-8" />
        <UseCases data-id="element-9" />
        <ProofBand data-id="element-10" />
        <Founders data-id="element-11" />
        <CTASection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-14">
      <Routes data-id="element-15">
        <Route path="/" element={<HomePage data-id="element-17" />} data-id="element-16" />
        <Route path="/partners" element={<Partners data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}